/**
 * Enum representing different types of devices.
 */
export enum DeviceTypes {
  /**
   * Represents a mobile device.
   */
  mobile = "mobile",

  /**
   * Represents a tablet device.
   */
  tablet = "tablet",

  /**
   * Represents a desktop device.
   */
  desktop = "desktop",

  /**
   * Represents a wide desktop device.
   */
  wideDesktop = "wideDesktop",
}
